import { saveAs } from 'file-saver';
import type { Dispatch, AnyAction } from 'redux';

import type { LogViewModel } from 'ab-viewModels/log.viewModel';
import type { LogFileViewModel } from 'ab-viewModels/logFileViewModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { DOWNLOAD_LOGS } from 'af-constants/reduxForms';
import API from 'af-constants/routes/api';

import type { TableContent } from 'ab-common/dataStructures/tableContent';
import { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function findById(logId: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<LogViewModel>(API.V1.LOGS.FIND_BY_ID(logId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllForCompanyTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<TableContent<LogViewModel>>(API.V1.LOGS.COMPANY_TABLE(data));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllForOrganizationTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<TableContent<LogViewModel>>(API.V1.LOGS.ORGANIZATION_TABLE(data));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function downloadForCompany(filename: string, startDate: Date, endDate: Date) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const startDateString = TimeUtils.formatDate(startDate, TimeFormat.DB_DATE_ONLY);
			const endDateString = TimeUtils.formatDate(endDate, TimeFormat.DB_DATE_ONLY);

			const data = await http.get(API.V1.LOGS.COMPANY_DOWNLOAD(startDateString, endDateString), { responseType: 'blob', submitting: DOWNLOAD_LOGS });
			saveAs(data, filename);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function downloadForOrganization(filename: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = await http.get(API.V1.LOGS.ORGANIZATION_DOWNLOAD, { responseType: 'blob' });
			saveAs(data, filename);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findLastBucketEntry() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<LogFileViewModel>(API.V1.LOGS.FIND_LAST_BUCKET_ENTRY);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
